<template>
  <v-dialog v-if="hasSupportTicket" class="support-dialog-container" content-class="support-dialog" v-model="dialogVisible" max-width="1180">
    <template v-slot:activator="{ on, attrs }">
      <v-btn height="36px" class="support-activator-btn" icon v-bind="attrs" v-on="on" :title="iconTitle">
        <v-badge left offset-x="15px" :color="ticket.quelpUnread ? '#7b5cd6' : 'grey'" :content="timeStamp" style="text-transform: none">
          <!-- Ampel: rot = Bestellung on hold, blau = offene Frage ohne Hold; beantwortet = kein Icon -->
          <v-icon v-if="ticket?.quelpId" :color="state === 'hold' ? '#e53935' : '#1e88e5'">mdi-alpha-q-box</v-icon>
          <v-icon v-else color="warning">mdi-headset</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <div class="support-dialog-container__content" v-if="ticket">
      <div class="support-dialog-container__grid">
        <SupportOrderTasks :ticket="ticket" />
        <QuelpThread :ticket="ticket" compact @open-order="goToSupport" @sent="dialogVisible = false" />
      </div>
      <div class="support-dialog-container__footer">
        <v-btn text small color="#6a4fc4" @click="goToSupport"><v-icon small left>mdi-headset</v-icon>In der Support-Ansicht öffnen</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getDateFromNowShort } from "@/utils";
import SupportOrderTasks from "@/components/Support/SupportOrderTasks";
import QuelpThread from "@/components/Support/QuelpThread";

// Ticket-Dialog an Task- und Bestell-Karten: gleiche Bausteine wie /support.
export default {
  name: "SupportDialog",
  components: { SupportOrderTasks, QuelpThread },
  data() {
    return {
      dialogVisible: false,
    };
  },
  props: {
    orderId: {
      required: true,
    },
  },
  computed: {
    ...mapGetters(["ticketsActive"]),
    // Zeit seit der letzten KUNDEN-Nachricht (wie lange wartet der Kunde).
    timeStamp() {
      return getDateFromNowShort(this.lastCustomerAt || this.ticket.quelpLastMessageAt || this.ticket.created);
    },
    lastCustomerAt() {
      let last = null;
      Object.values(this.ticket.quelpTickets || {}).forEach((t) => {
        (t.messages || []).forEach((m) => {
          if (m.direction === "inbound" && m.date && (!last || m.date > last)) last = m.date;
        });
      });
      return last;
    },
    quelpList() {
      return Object.values(this.ticket.quelpTickets || {});
    },
    // 'hold' | 'open' | 'done'
    state() {
      if (this.quelpList.some((t) => t.onHold) || this.ticket.quelpOnHold) return "hold";
      if (this.quelpList.some((t) => t.status === "open")) return "open";
      if (!this.quelpList.length && this.ticket.pending) return this.ticket.waiting ? "hold" : "open";
      return "done";
    },
    iconTitle() {
      return this.state === "hold" ? "Support: Bestellung angehalten" : this.state === "open" ? "Support: offene Frage, Produktion läuft weiter" : "";
    },
    ticket() {
      return (
        this.ticketsActive.find((ticket) => {
          return ticket.orderUid + "" === this.orderId + "";
        }) || null
      );
    },
    hasSupportTicket() {
      return this.ticket !== null && this.state !== "done";
    },
  },
  methods: {
    goToSupport() {
      this.dialogVisible = false;
      this.$router.push({ path: "/support", query: { order: String(this.orderId) } }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.support-dialog { overflow: hidden !important; }
</style>
<style lang="scss" scoped>
.support-activator-btn {
  margin-left: 8px;
}
.support-dialog-container {
  &__content { background: #f4f3f8; border-radius: 14px; padding: 12px; display: flex; flex-direction: column; height: 86vh; max-height: 86vh; box-sizing: border-box; }
  &__grid { flex: 1 1 auto; min-height: 0; display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr); grid-template-rows: minmax(0, 1fr); gap: 12px;
    > * { min-height: 0; }
    > :first-child { overflow-y: auto; }
    > :last-child { overflow: hidden; display: flex; flex-direction: column; }
    @media (max-width: 900px) { grid-template-columns: 1fr; grid-template-rows: minmax(0, 1fr) minmax(0, 1fr); } }
  &__footer { display: flex; justify-content: flex-end; padding-top: 8px; flex: 0 0 auto; }
}
</style>
